import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-[#121212] text-gray-400 px-6 md:px-16 py-12 text-sm">
            {/* Top section */}
            <div className="flex flex-col md:flex-row justify-between gap-12 mb-8">
                {/* Left logo + description */}
                <div className="md:w-1/3">
                    <div className="text-red-500 font-mono text-lg font-semibold mb-2">
                        &lt;SiberLab ID/&gt;
                    </div>
                    <p>
                        Strengthening Indonesia's cybersecurity posture through education, training, and professional services.
                    </p>
                </div>

                {/* Menu columns */}
                <div className="grid grid-cols-2 md:grid-cols-3 gap-6 md:gap-16">
                    <div>
                        <h4 className="text-white font-semibold mb-2">Services</h4>
                        <ul className="space-y-1">
                            <li><a href="#services" className="hover:text-white">Cybersecurity Training</a></li>
                            <li><a href="#services" className="hover:text-white">Red Team Services</a></li>
                            <li><a href="#services" className="hover:text-white">Akademi Siber</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-semibold mb-2">Company</h4>
                        <ul className="space-y-1">
                            <li><a href="#about" className="hover:text-white">About Us</a></li>
                            {/* <li><a href="#team" className="hover:text-white">Team</a></li>
                            <li><a href="#careers" className="hover:text-white">Careers</a></li> */}
                            <li><a href="#contact" className="hover:text-white">Contact</a></li>
                        </ul>
                    </div>
                    <div>
                        <h4 className="text-white font-semibold mb-2">Resources</h4>
                        <ul className="space-y-1">
                            <li><span  className="hover:text-white">[SOON] Blog</span></li>
                            {/* <li><a href="" disabled className="hover:text-white">[SOON] Blog</a></li> */}
                            {/* <li><a href="#webinars" className="hover:text-white">Webinars</a></li>
                            <li><a href="#case-studies" className="hover:text-white">Case Studies</a></li>
                            <li><a href="#faq" className="hover:text-white">FAQ</a></li> */}
                        </ul>
                    </div>
                </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 my-4" />

            {/* Bottom copyright + policy links */}
            <div className="flex flex-col md:flex-row justify-between items-center text-xs gap-4">
                <p>© {new Date().getFullYear()} SiberLab ID. All rights reserved.</p>
                <div className="flex gap-4">
                    <a href="#privacy" className="hover:text-white">Privacy Policy</a>
                    <a href="#terms" className="hover:text-white">Terms of Service</a>
                    <a href="#cookie" className="hover:text-white">Cookie Policy</a>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
